var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAuthenticityinline = function SvgAuthenticityinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 19 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeMiterlimit: 10,
    strokeWidth: 0.939,
    d: "M14.763 4.21c-3.66-.752-5.203-2.698-5.203-2.698h-.13S7.374 4.113 2.37 4.455v8.498s-.136 3.768 7.058 6.033h.131c7.195-2.26 7.059-6.033 7.059-6.033V7.978"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeMiterlimit: 10,
    strokeWidth: 0.939,
    d: "M17.64 4.113 8.733 12.64l-2.99-2.985"
  })));
};
export default SvgAuthenticityinline;